import { getUserRole } from "Redux/Query";

export const userContainsRole = state => roles => roles.includes(getUserRole(state));